import React, { useState } from "react";
import emailjs from "@emailjs/browser";
import { useNavigate } from "react-router-dom";
import SEOHelmet from '../components/SEOHelmet';

const ForgotPassword = () => {
const navigate = useNavigate();
  const [email,setEmail] = useState("");
  const [otp,setOtp] = useState("");
  const [generatedOtp,setGeneratedOtp] = useState("");

  function generateOTP(){
    return Math.floor(100000 + Math.random()*900000);
  }

  function sendOTP(){

    const newOtp = generateOTP();
    setGeneratedOtp(newOtp);

    emailjs.send(
    "service_2k3vn3q",
"template_kr57ou3",
      {
        email: email,
        otp: newOtp
      },
      "wjtOfftpYOFCCebGk"
    )
    .then(()=>{
      alert("OTP Sent to Email");
    })
    .catch((error)=>{
      console.log(error);
    });

  }

  function verifyOTP(){

    if(otp === generatedOtp){
      alert("OTP Verified");
      navigate("/reset-password", { state: { email, otp } });
    }
    else{
      alert("Wrong OTP");
    }

  }

  return(
    <>
      <SEOHelmet page="forgotPassword" canonicalUrl="https://www.assetflows.in/forgot-password" noIndex />
      <div style={{
      backgroundColor:"#0b3d91",
      minHeight:"100vh",
      display:"flex",
      justifyContent:"center",
      alignItems:"center",
      fontFamily:"Arial"
    }}>

      <div style={{
        backgroundColor:"white",
        padding:"40px",
        borderRadius:"12px",
        width:"380px",
        textAlign:"center",
        boxShadow:"0 8px 20px rgba(0,0,0,0.25)"
      }}>

        <h2 style={{
       
          color:"black",
          padding:"12px",
          borderRadius:"8px",
          marginBottom:"25px"
        }}>
          Forgot Password
        </h2>

        <input
          type="email"
          placeholder="Enter your email"
          value={email}
          onChange={(e)=>setEmail(e.target.value)}
          style={{
            width:"100%",
            padding:"12px",
            borderRadius:"6px",
            border:"1px solid #ccc",
            marginBottom:"15px",
            fontSize:"14px"
          }}
        />

        <button 
          onClick={sendOTP}
          style={{
            width:"100%",
            padding:"12px",
            backgroundColor:"#0b3d91",
            color:"white",
            border:"none",
            borderRadius:"6px",
            cursor:"pointer",
            fontWeight:"bold",
            marginBottom:"20px"
          }}
        >
          Send OTP
        </button>

        <input
          type="text"
          placeholder="Enter OTP"
          value={otp}
          onChange={(e)=>setOtp(e.target.value)}
          style={{
            width:"100%",
            padding:"12px",
            borderRadius:"6px",
            border:"1px solid #ccc",
            marginBottom:"15px",
            fontSize:"14px"
          }}
        />

        <button 
          onClick={verifyOTP}
          style={{
            width:"100%",
            padding:"12px",
            backgroundColor:"#0b3d91",
            color:"white",
            border:"none",
            borderRadius:"6px",
            cursor:"pointer",
            fontWeight:"bold"
          }}
        >
          Verify OTP
        </button>

      </div>

    </div>
    </>

  );

};

export default ForgotPassword;